module.exports = __webpack_public_path__ + "img/yasuoji.b7bd34c6.jpg";